
import { I18n } from '@aws-amplify/core';
import { Alert, Button, Flex, Heading, PasswordField, useTheme } from '@aws-amplify/ui-react';
import { CircularProgress } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Auth } from 'aws-amplify';
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Branding } from '../../branding';
import { setUser } from '../../redux/actions';
import Footer from '../Footer/Footer';
import AppSnackbar from '../Snackbar/Snackbar';

const config = require("Config");


const useStyles = makeStyles((theme) => ({

    rootGrid: {
        marginTop: theme.spacing(10),
        paddingBottom: theme.spacing(3),
    },
    grid: {
        justifyContent: 'center',
    },
    box: {
        width: '90%',
        maxWidth: 650,
    },
    card: {
        minWidth: "25em",
        maxWidth: '27em',
    },
    cardMedia: {
        width: 200,
        height: 90,
        backgroundSize: 'contain',
    },
    cardHeader: {
        paddingBottom: 0
    },
    cardContent: {
        justifyContent: 'left',
        display: 'flex',
        padding: "4em 2em",
        textAlign: 'left',
        "&:last-child": {
            paddingBottom: theme.spacing(5)
        }
    },
    boxExpandIdp: {
        textAlign: 'center',
    },
    chipExpand: {
        backgroundColor: Branding.secondary,
        color: Branding.white,
        '&:hover': {
            backgroundColor: Branding.secondary,
            opacity: Branding.opacityHover,
        },
    },
    expandIcon: {
        color: Branding.white,
    },
    divider: {
        marginBottom: theme.spacing(2)
    },
    typoToS: {
        paddingTop: theme.spacing(3),

    },
    linkTos: {
        fontSize: 12,
        fontWeight: "bold",
        color: Branding.secondary,
        '&:hover': {
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    linkImprint: {
        fontSize: 14,
        '&:hover': {
            cursor: 'pointer',
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    link: {
        fontSize: 12,
        fontWeight: "bold",
        color: Branding.link,
        '&:hover': {
            cursor: 'pointer',
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    midBul: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        color: Branding.secondary,
    },
    button: {
        width: "100%",
        borderRadius: "0px",
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        marginTop: theme.spacing(2),
    },
    errorMessage: {
        color: "red",
        marginTop: theme.spacing(1),
        fontWeight: "bold",
        fontSize: "12px"
    }
}));

const mapStateToProps = (state) => {
    return {
        lang: state.app.lang,
        user: state.app.user,
        tos: state.app.tos
    }
}

let queryStringParams = new URLSearchParams(
    decodeURIComponent(window.location.search)
);

const ConfirmPassword = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { tokens } = useTheme();
    const classes = useStyles();
    const [success, setSuccess] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [validationError, setValidationError] = React.useState('');
    const isSignInProgress = useRef(false);

    React.useEffect(() => {
        if (location.pathname === "/confirmPassword" && queryStringParams.get("token")) {
            let fn = async () => {
                try {
                    if (props.user) {
                        isSignInProgress.current = true;
                        await Auth.signOut();
                        window.location = `/confirmPassword?${queryStringParams.get("token")}`;
                        return;
                    }
                } catch (error) {
                    console.log(error);
                }
            };
            if (!isSignInProgress.current)
                fn();
        }
    }, []);


    const validatePassword = (e) => {
        // Define your password policy using regular expressions and validation rules
        const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/
        const passwordLengthRule = password.length >= 8;
        const passwordMatchRule = password === confirmPassword;

        // Check if the password meets all validation rules
        if (!passwordLengthRule) {
            setValidationError('Password must be at least 8 characters long');
        } else if (!passwordMatchRule) {
            setValidationError('The passwords you entered do not match.');
        }
        else if (!passwordRegex.test(password)) {
            setValidationError('Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one special character, and one number');
        } else {
            setValidationError('');
            setIsLoading(true);
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: queryStringParams.get("token"), password: password })
            };
            fetch(`${config.apiHost}/api/v1/confirmPassword`, requestOptions).then(async (response) => {
                setIsLoading(false);
                if (response.ok) {
                    const result = await response.json();
                    setSuccess(result.message);
                    setTimeout(() => {
                        navigate("/", { replace: true });
                    }, 2000);
                } else if (response.status === 401) {
                    setValidationError("invalid token or token expired. Please request a new one.");
                }
                else if (400 <= response.status && response.status < 500) {
                    setValidationError("Invalid request");
                } else {
                    setValidationError("Something went wrong");
                }
            }).catch((error) => {
                console.log(error);
                setValidationError(error.message || 'Something went wrong');
            });
        }
        e.preventDefault();
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };

    return (
        <div>

            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                className={classes.rootGrid}
            >
                <CardMedia
                    className={classes.cardMedia}
                    image={"https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png"}
                    title={Branding.appName}
                />
            </Grid>

            {!success ?
                <Grid container className={classes.grid}>
                    <Card variant="outlined" className={classes.card}>
                        <CardContent className={classes.cardContent}>

                            <Flex as="form" direction="column" gap={tokens.space.medium}>
                                <Heading level={3}>Change Password</Heading>
                                <div style={{ fontSize: "12px" }}>Your password should be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.</div>
                                <PasswordField
                                    label="New password"
                                    name="new_password"
                                    value={password}
                                    onChange={handlePasswordChange}
                                    style={{ alignSelf: "flex-start" }}
                                    autoComplete="new-password"
                                    descriptiveText=""
                                />
                                <PasswordField
                                    label="Confirm password"
                                    value={confirmPassword}
                                    onChange={handleConfirmPasswordChange}
                                    name="confirm_password"
                                    autoComplete="new-password"
                                />
                                <Button variation={!isLoading ? "primary" : "secondary"} className={classes.button} type="submit" onClick={validatePassword}>
                                    {isLoading ? <div style={{ display: "flex", alignItems: "center" }}><CircularProgress variant='indeterminate' thickness={2} size={"1em"} /> <span style={{ marginLeft: "5px" }}>Please wait...</span></div> : 'Submit'}
                                </Button>
                                {validationError ? <Alert variation="error"> <p style={{ fontSize: "12px" }}>{validationError}</p></Alert> : null}
                            </Flex>

                        </CardContent>
                    </Card >
                </Grid>
                :
                <Grid container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <CircularProgress variant='indeterminate' thickness={3} size={"3em"} />
                    {

                        <Typography style={{
                            marginBottom: "2em",
                            fontWeight: 'bold',
                            marginTop: "2em",
                            fontSize: "12px",
                            color: Branding.primary
                        }}> Redirecting to login. Please wait… </Typography>
                    }

                </Grid>
            }
            <Footer></Footer>

            {success && (
                <AppSnackbar ops={{
                    open: true,
                    vertical: 'bottom',
                    horizontal: 'center',
                    autoHide: 5000,
                    message: success,
                    type: "success"
                }} />
            )}
        </div >
    );
}

export default connect(mapStateToProps, { setUser })(ConfirmPassword);
